import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import styled from "styled-components";
import { theme } from "../styles/appTheme";

type StepHeaderProps = {
  completed: boolean;
};

export default function StepHeader({ completed }: StepHeaderProps) {
  return (
    <ProgressRow>
      <ProgressStep>
        <Dot $done>
          <CheckRoundedIcon sx={{ fontSize: 24 }} />
        </Dot>
        <ProgressLabel>物件情報</ProgressLabel>
      </ProgressStep>
      <ProgressLine $half={!completed} />
      <ProgressStep>
        <Dot $done={completed}>
          {completed ? <CheckRoundedIcon sx={{ fontSize: 24 }} /> : null}
        </Dot>
        <ProgressLabel>完了</ProgressLabel>
      </ProgressStep>
    </ProgressRow>
  );
}

const ProgressRow = styled.div({
  display: "flex",
  alignItems: "flex-start",
});

const ProgressStep = styled.div({
  width: 73,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 6,
  flexShrink: 0,
});

const Dot = styled.span<{ $done?: boolean }>(({ $done }) => ({
  width: 24,
  height: 24,
  borderRadius: "50%",
  background: $done ? theme.palette.main : theme.palette.divider,
  color: theme.palette.white,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const ProgressLine = styled.span<{ $half?: boolean }>(({ $half }) => ({
  height: 4,
  flex: 1,
  marginTop: 10,
  marginLeft: -24.5,
  marginRight: -24.5,
  background: $half
    ? `linear-gradient(to right, ${theme.palette.main} 45%, ${theme.palette.divider} 45%)`
    : theme.palette.primary,
}));

const ProgressLabel = styled.span({
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.5,
  textAlign: "center",
});
